import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomHttpClient } from './custom-http-client.service';
import { HttpClient } from "@angular/common/http";

/**
 * AI API Request interface
 */
export interface AiApiRequest {
  message: string;
  user_id?: number;
  practice_id?: number;
  screen?: string;
  active_tab?: string;
  patient_id?: string;
  r_patient_id?: number | null;
  program_id?: number | null;
  timestamp?: string;
  session_id?: string;
  chat_id?: string;
  context?: {
    screen_name?: string;
    active_tab?: string;
    patient_id?: number | null;
    program_id?: number | null;
    route_url?: string;
    user_info?: any;
  };
}

/**
 * AI API Response interface
 */
export interface AiApiResponse {
  message: string;
  timestamp: string;
  context_understood?: boolean;
}

/**
 * Real AI API Service
 * Connects to the actual backend AI service
 * Replace the API_ENDPOINT with your actual endpoint once available
 */
@Injectable({
  providedIn: 'root'
})
export class RealAiApiService {

  // TODO: Update this endpoint when the real AI API is ready
  private readonly API_ENDPOINT_get = 'https://test-bot-11.uc.r.appspot.com/health';  // Replace with your actual endpoint
  private readonly API_ENDPOINT_post = 'https://test-bot-11.uc.r.appspot.com/wellwink/aichat/';  // Replace with your actual endpoint

  constructor(private httpClient: CustomHttpClient,
    public http: HttpClient) { }

  /**
   * Send a message to the real AI backend
   * @param request - The AI API request payload
   * @returns Observable of AI response
   */
  public sendMessage(request: AiApiRequest): Observable<AiApiResponse> {

    let a = {
      patient_id: "P0001",
      session_id: "S1",
      chat_id: "C1",
      message: "Hi, I have diabetes. What should I focus on daily?"
    }
    // Make POST request to real AI backend
    return this.http.post(this.API_ENDPOINT_post, request).map(
      (response: any) => {
        return response;
        // Transform backend response to match AiApiResponse interface
        /*return {
          message: response.message || response.response || response.data?.message,
          timestamp: response.timestamp || new Date().toISOString(),
          context_understood: response.context_understood !== false
        } as AiApiResponse;*/
      }
    );
  }


  getCurrentUserChats(): Promise<any> {
    return this.http.get(this.API_ENDPOINT_get).toPromise()
      .then(res => res);
  }

  /**
   * Alternative: If your backend has a different response structure,
   * modify the mapping above or create additional methods here
   *
   * Example for streaming responses:
   */
  // public sendMessageStream(request: AiApiRequest): Observable<string> {
  //   return this.httpClient.post(this.API_ENDPOINT + '/stream', request);
  // }
}
